import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../core/guards/auth-guard.service';
import { DetailBeneficiaireComponent } from './beneficiaires/detail-beneficiaire/detail-beneficiaire.component';
import { ListBeneficiaireComponent } from './beneficiaires/list-beneficiaire/list-beneficiaire.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { DetailMissionPlaceComponent } from './mission-place/detail-mission-place/detail-mission-place.component';
import { ListMissionPlaceComponent } from './mission-place/list-mission-place/list-mission-place.component';
import { DetailEmployeeComponent } from './employees/detail-employee/detail-employee.component';
import { ListEmployeeComponent } from './employees/list-employee/list-employee.component';
import { MapComponent } from './map/map/map.component';
import { ProfileComponent } from './profile/profile/profile.component';
import { ListSpecialiteComponent } from './specialites/list-specialite/list-specialite.component';
import { HasVehicleAccessGuard } from '../core/guards/has-vehicle-access.guard';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { AuthorityGuard } from '../core/guards/authority.guard';
import { Authority } from '../shared/models/security/authority';
import { UserInfosComponent } from './profile/user-infos/user-infos.component';
import { MessagerieComponent } from './messagerie/messagerie.component';
import { ListUsersComponent } from './users/list-user/list-user.component';
import { DetailUserComponent } from './users/detail-user/detail-user.component';
import { DetailRoleComponent } from './role/detail-role/detail-role.component';
import { ListRolesComponent } from './role/list-role/list-role.component';
import { ListTauxReconnaissanceComponent } from './tauxReconnaissance/list-tauxReconnaissance/list-tauxReconnaissance.component';
import { ListNiveauEtudeComponent } from './niveauEtude/list-niveauEtude/list-niveauEtude.component';
import { ListNiveauQualificationComponent } from './niveauQualification/list-niveauQualification/list-niveauQualification.component';
import { ListTypeStructureComponent } from './typeStructure/list-typeStructure/list-typeStructure.component';
import { ListModaliteReunionComponent } from './modaliteReunion/list-modaliteReunion/list-modaliteReunion.component';
import { ListObjectifProComponent } from './objectifPro/list-objectifPro/list-objectifPro.component';
import { ListOrigineDemandeComponent } from './origineDemande/list-origineDemande/list-origineDemande.component';
import { ListAmenagementComponent } from './amenagement/list-amenagement/list-amenagement.component';
import { ListNotificationEmailComponent } from './notificationEmail/list-notificationEmail/list-notificationEmail.component';
import { ListExpertiseComponent } from './expertise/list-expertise/list-expertise.component';
import { ListSituationComponent } from './situation/list-situation/list-situation.component';
import { ListPrestationComponent } from './prestation/list-prestation/list-prestation.component';
import { DetailPrestationComponent } from './prestation/detail-prestation/detail-prestation.component';
import { ListTypeEntretienComponent } from './typeEntretien/list-typeEntretien/list-typeEntretien.component';
import { ListTacheComponent } from './tache/list-tache/list-tache.component';
import { InstitutionFormComponent } from './systeme/institution/institution-form/institution-form.component';
import { ListTypeFormationComponent } from './typeFormation/list-typeFormation/list-typeFormation.component';
import { ListDepartementComponent } from './departement/list-departement/list-departement.component';
import { ListRegionComponent } from './region/list-region/list-region.component';
import { ListServiceComponent } from './service/list-service/list-service.component';
import { ListInfosasComponent } from './infosas/list-prestation/list-prestation.component';
import { DetailInfosasComponent } from './infosas/detail-prestation/detail-prestation.component';
import { ListCanalCommunicationComponent } from './canalCommunication/list-canalCommunication/list-canalCommunication.component';
import { ListTypeHandicapComponent } from './typeHandicap/list-typeHandicap/list-typeHandicap.component';
import { ListEligibiliteBeneficiaireComponent } from './eligibiliteBeneficiaire/list-amenagement/list-eligibiliteBeneficiaire.component';
import { ListStatutProfessionnelComponent } from './statutProfessionnel/list-statutProfessionnel/list-statutProfessionnel.component';
import { ListPrescripteurComponent } from './prescripteur/list-prescripteur/list-prescripteur.component';
import { DetailPrescripteurComponent } from './prescripteur/detail-prescripteur/detail-prescripteur.component';
import { InfosasGuard } from '../core/guards/infosas.guard';
import { ListTypeDocumentComponent } from './typeDocument/list-typeDocument/list-typeDocument.component';
import { DetailBonCommandeComponent } from './bonCommande/detail-bonCommande/detail-bonCommande.component';
import { ListBonCommandeComponent } from './bonCommande/list-bonCommande/list-bonCommande.component';
import { ListSituationFamilialeComponent } from './situationFamiliale/list-situationFamiliale/list-situationFamiliale.component';
import { ListTypeEntrepriseComponent } from './typeEntreprise/list-typeEntreprise/list-typeEntreprise.component';
import { DetailEmployeurComponent } from './employeur/detail-employeur/detail-employeur.component';
import { ListEmployeurComponent } from './employeur/list-employeur/list-employeur.component';
const routes: Routes = [
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: 'gestion',
		children: [
			{
				path: 'employees',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListEmployeeComponent
					},
					{
						path: ':id',
						component: DetailEmployeeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'specialites',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListSpecialiteComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'users',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListUsersComponent
					},
					{
						path: ':id',
						component: DetailUserComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'bonCommande',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListBonCommandeComponent
					},
					{
						path: ':id',
						component: DetailBonCommandeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'roles',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListRolesComponent
					},
					{
						path: ':id',
						component: DetailRoleComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'notificationEmail',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListNotificationEmailComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'prescripteurs',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListPrescripteurComponent
					},
					{
						path: ':id',
						component: DetailPrescripteurComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'employeurs',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListEmployeurComponent
					},
					{
						path: ':id',
						component: DetailEmployeurComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
		]
	},
	{
		path: 'prestation',
		children: [
			{
				path: 'appuis-specifiques',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					profiles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListPrestationComponent
					},
					{
						path: ':id',
						component: DetailPrestationComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'infosas',
				canActivate: [AuthGuardService, AuthorityGuard, InfosasGuard],
				data: {
					profiles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.CHARGE_MISSION
					]
				},
				children: [
					{
						path: 'list',
						component: ListInfosasComponent
					},
					{
						path: ':id',
						component: DetailInfosasComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
		]
	},
	{
		path: 'parametrage',
		children: [
			{
				path: 'tauxReconnaissance',
				canActivate: [AuthGuardService, AuthorityGuard],
				// data: {
				// 	profiles: [
				// 		Authority.DIRECTEUR_STRUCTURE,
				// 		Authority.RESPONSABLE_CENTRE,
				// 		Authority.PLANIFICATEUR
				// 	]
				// },
				children: [
					{
						path: 'list',
						component: ListTauxReconnaissanceComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'niveauEtude',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListNiveauEtudeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'niveauQualification',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListNiveauQualificationComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeStructure',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeStructureComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeEntreprise',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeEntrepriseComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeEntretien',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeEntretienComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeDocument',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeDocumentComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeFormation',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeFormationComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'departement',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListDepartementComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'region',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListRegionComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'service',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListServiceComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'modaliteReunion',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListModaliteReunionComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'origineDemande',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListOrigineDemandeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'objectifPro',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListObjectifProComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'amenagement',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListAmenagementComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'situationFamiliale',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListSituationFamilialeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'canalCommunication',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListCanalCommunicationComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'tache',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTacheComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'expertise',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListExpertiseComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'typeHandicap',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListTypeHandicapComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'situation',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListSituationComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'eligibiliteBeneficiaire',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListEligibiliteBeneficiaireComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'statutProfessionnel',
				canActivate: [AuthGuardService, AuthorityGuard],
				children: [
					{
						path: 'list',
						component: ListStatutProfessionnelComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
		]
	},
	{
		path: 'systeme',
		children: [
			{
				path: 'systeme',
				canActivate: [AuthGuardService, AuthorityGuard],
				// data: {
				// 	profiles: [
				// 		Authority.DIRECTEUR_STRUCTURE,
				// 		Authority.RESPONSABLE_CENTRE,
				// 		Authority.PLANIFICATEUR
				// 	]
				// },
				children: [
					{
						path: 'form',
						component: InstitutionFormComponent
					},
					{ path: '', redirectTo: 'form', pathMatch: 'full' }
				]
			},
		]
	},
	// {
	// 	path: 'prestation',
	// 	//component: ListPrestationComponent,
	// 	canActivate: [AuthGuardService],
	// 	children: [
	// 		{
	// 			path: 'list',
	// 			component: ListPrestationComponent
	// 		},
	// 		{
	// 			path: ':id',
	// 			component: DetailPrestationComponent
	// 		},
	// 		{ path: '', redirectTo: 'list', pathMatch: 'full' }
	// 	]
	// },
	{
		path: 'beneficiaires',
		//component: ListPrestationComponent,
		canActivate: [AuthGuardService],
		children: [
			{
				path: 'list',
				component: ListBeneficiaireComponent
			},
			{
				path: ':id',
				component: DetailBeneficiaireComponent
			},
			{ path: '', redirectTo: 'list', pathMatch: 'full' }
		]
	},
	{
		path: 'map',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			profiles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR
			]
		},
		children: [
			{
				path: ':id',
				component: MapComponent
			},
			{
				path: '',
				component: MapComponent
			}
		]
	},
	{
		path: 'espace-perso',
		component: ProfileComponent,
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			profiles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.INTERVENANT
			]
		},
		children: [
			{ path: 'securite', component: ChangePasswordComponent },
			{ path: 'profil', component: UserInfosComponent },
			{ path: '', redirectTo: 'profil', pathMatch: 'full' }
		]
	},
	{
		path: 'messagerie',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			profiles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.INTERVENANT
			]
		},
		component: MessagerieComponent
	},

];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProtectedRoutingModule {}
